import { SET_CAT_FILTER } from '../actions'

export const DEFAULT_CAT_FILTER = 'defaultCatFilter'

let defaultCatFilter = []

let defaultState = {
    [DEFAULT_CAT_FILTER]: defaultCatFilter
}

export default function filtercats(state = defaultState, action) {
    switch(action.type) {        
        case SET_CAT_FILTER:
            return Object.assign({}, state, {
                catfilter: state.hasOwnProperty('catfilter') ? 
                    (state.catfilter.includes(action.payload) ? state.catfilter.filter(cat => action.payload !== cat) : [...state.catfilter, action.payload] ) 
                    : [action.payload]
            });

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/filtercats.js